<script setup>

const colorMode = useColorMode()

const modes = ['light', 'dark']

const nextModeIcons = {
  light: '🌕',
  dark: '🌑',
}

const nextMode = computed(() => {
  const currentModeIndex = modes.indexOf(colorMode.preference)
  const nextModeIndex = currentModeIndex+1 >= modes.length ? 0 : currentModeIndex+1

  return modes[nextModeIndex]
})

const nextModeIcon = computed(() => nextModeIcons[nextMode.value])

const toggleMode = () => colorMode.preference = nextMode.value

</script>

<template>
  <ClientOnly>
    <button
      class="flex items-center space-x-2 hover:bg-slate-800 hover:text-slate-200 dark:hover:bg-slate-200 dark:hover:text-slate-800 px-2 py-1 text-slate-800 text-base"
      @click="toggleMode"
    >
      {{ nextModeIcon }}<span class="ml-2">switch to {{ nextMode }}</span>
    </button>
  </ClientOnly>
</template>